import actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    roles: [],
    currentSelectedRole: {},
    rolesTotal: null,
    rolesLoading: false,
    page: 1,
    perPage: 5,
  },
  mutations,
  actions,
};
